import { composeIO } from 'react-compose-io'
import { ModalSelecaoParceiroDashboardMassaView } from './ModalSelecaoParceiroDashboardMassa.View'
import { ModalSelecaoParceiroDashboardMassaIO } from './ModalSelecaoParceiroDashboardMassa.IO'

export const ModalSelecaoParceiroDashboardMassa = composeIO(ModalSelecaoParceiroDashboardMassaView, ModalSelecaoParceiroDashboardMassaIO)
